import { render, staticRenderFns } from "./add-season.component.vue?vue&type=template&id=325e5048&scoped=true&"
import script from "./add-season.component.vue?vue&type=script&lang=ts&"
export * from "./add-season.component.vue?vue&type=script&lang=ts&"
import style0 from "./add-season.component.vue?vue&type=style&index=0&id=325e5048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e5048",
  null
  
)

export default component.exports